import { readAppLanguage, translationKey } from '../i18n';

export function formatPauseUntil(until) {
    if (readAppLanguage() === 'ko') return until.slice(5).replace('-', translationKey('월 '));
    return new Intl.DateTimeFormat(readAppLanguage() === 'ja' ? 'ja-JP' : 'en-US', { month: 'short', day: 'numeric' })
        .format(new Date(`${until.slice(0, 10)}T12:00:00`));
}
